import { render, staticRenderFns } from "./BrandLogoTextbox.vue?vue&type=template&id=7e19fe24&"
import script from "./BrandLogoTextbox.vue?vue&type=script&lang=js&"
export * from "./BrandLogoTextbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports